import { render } from "./InstitutionalCapabilityTab.vue?vue&type=template&id=8bc91f7c&scoped=true"
import script from "./InstitutionalCapabilityTab.vue?vue&type=script&lang=js"
export * from "./InstitutionalCapabilityTab.vue?vue&type=script&lang=js"

import "./InstitutionalCapabilityTab.vue?vue&type=style&index=0&id=8bc91f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc91f7c"]])

export default __exports__